module.exports = __webpack_public_path__ + "static/media/footer.2263580d.svg";